<template>
    <!-- 这个是显示全部的 -->
    <van-pull-refresh v-model="isLoading" @refresh="getList">
        <div class="man-container">
            <div class="flex-form-info">
                <!--                <div v-for="(item, index) in list" :key="index" @touchstart.native="ontouchstart">-->
                <!--                    <div class="fee-item" @click="onClick(item)">-->
                <!--                        <div>-->
                <!--                            <img :src="item.src"/>-->
                <!--                        </div>-->
                <!--                        <div>-->
                <!--                            {{item.itemName}}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div v-for="(item, index) in list" :key="index">
                    <mobile-fee-button :item="item"></mobile-fee-button>
                </div>
            </div>
        </div>
    </van-pull-refresh>

</template>

<script>
    import apiChooseFee from "api/choose-fee"
    import log from "utils/log"
    import {getState, setState} from "utils/state"
    import MobileFeeButton from "components/mobile-fee-button/index";

    export default {
        components: {MobileFeeButton},
        data() {
            return {
                list: [],
                isLoading: false,
                firstLoading: true,
            }
        },
        methods: {
            onClick(item) {
                setState('select-item', item.origin)
                this.$router.push({
                    name: 'choose-fee-detail',
                })
            },
            ontouchstart(e) {
                log('33 touch it', e)
            },
            getList() {
                this.isLoading = true
                apiChooseFee.list().then(res => {
                    // this.list = res.data
                    const self = this
                    if (res.data) {
                        this.list = res.data.map(x => {
                            return {
                                name: x.itemName,
                                src: x.src,
                                onClick: (item) => self.onClick(item),
                                origin: x,
                            }
                        })
                    }


                    this.$nextTick(() => {
                        this.isLoading = false
                        this.firstLoading = false
                    })
                })
            }
        },
        created() {
            this.firstLoading = true
            this.getList()
        },
        mounted() {
        }

    }
</script>

<style lang='scss' scoped>
    .man-container {
        height: 100%;
        width: 100%;
        padding-top: 10px;

        .flex-form-info {
            height: 100%;
            width: 90%;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .fee-item {
                height: 26vw;
                width: 26vw;
                background: #42b983;
                /*margin-left: 10px;*/
                margin-bottom: 10px;
            }
        }
    }
</style>
